var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import MembershipInformation from "../subpages/accountTransactions/membership.information";
import ChangePassword from "../subpages/accountTransactions/change.password";
import AccountTransactions from "../subpages/accountTransactions/account.transactions";
import DepositMoney from "../subpages/financialTransactions/deposit.money";
import WithdrawMoney from "../subpages/financialTransactions/withdraw.money";
import MyBankAccounts from "../subpages/financialTransactions/my.bank.accounts";
import Iddia from "../subpages/gameOperations/iddia";
import SupportRequests from "../subpages/support/support.requests";
import MilliPiyango from "../subpages/gameOperations/milli.piyango";
import SayisalLoto from "../subpages/gameOperations/sayisal.loto";
import { useNavigate, useLocation } from "react-router-dom";
import SporToto from "../subpages/gameOperations/spor.toto";
import SupportDetail from '../subpages/support/support.detail';
import { Lottery } from "../subpages/gameOperations/lottery";
import { Scatch } from "../subpages/gameOperations/scatch";
import { TjkCoupons } from "../subpages/gameOperations/tjk";
import VRGameCoupons from '../subpages/gameOperations/vr.game.coupons';
export var gameOperationRoutes = [
    { label: 'İddaa Kuponlarım', basePath: '/hesabim/iddaa', defaultPath: '/hesabim/iddaa/devam-edenler' },
    { label: 'Sanal Oyun Kuponlarım', basePath: '/hesabim/sanal-oyun', defaultPath: '/hesabim/sanal-oyun' },
    { label: 'Spor Toto Kuponlarım', basePath: '/hesabim/spor-toto', defaultPath: '/hesabim/spor-toto/devam-edenler' },
    { label: 'Eşya Piyangosu Biletlerim', basePath: '/hesabim/esya-piyangosu', defaultPath: '/hesabim/esya-piyangosu/devam-eden-cekilisler' },
    { label: 'Oyna Kazan Kartlarım', basePath: '/hesabim/oyna-kazan', defaultPath: '/hesabim/oyna-kazan/kartlarim' },
    { label: 'At Yarışı Kuponlarım', basePath: '/hesabim/tjk', defaultPath: '/hesabim/tjk/devam-edenler' },
];
export function GameOperationsSelect() {
    var navigate = useNavigate();
    var location = useLocation();
    var active = gameOperationRoutes.find(function (r) { return location.pathname.startsWith(r.basePath); });
    return (_jsx("select", __assign({ className: "w-50 mb-2", value: (active === null || active === void 0 ? void 0 : active.basePath) || '', onChange: function (e) {
            var route = gameOperationRoutes.find(function (r) { return r.basePath === e.target.value; });
            if (route)
                navigate(route.defaultPath);
        } }, { children: gameOperationRoutes.map(function (r) { return _jsx("option", __assign({ value: r.basePath }, { children: r.label }), r.basePath); }) }), void 0));
}
export default function SubPageSelected(props) {
    var navigate = useNavigate();
    var subPagesRouter = {
        'uyelik': _jsx(MembershipInformation, {}, void 0),
        'guvenlik': _jsx(ChangePassword, {}, void 0),
        'hesap-hareketlerim': _jsx(AccountTransactions, { params: props.params }, void 0),
        'para-yatir': _jsx(DepositMoney, {}, void 0),
        'para-cek': _jsx(WithdrawMoney, {}, void 0),
        'banka-hesaplarim': _jsx(MyBankAccounts, {}, void 0),
        'iddaa': _jsx(Iddia, { params: props.params }, void 0),
        'sanal-oyun': _jsx(VRGameCoupons, {}, void 0),
        'spor-toto': _jsx(SporToto, { params: props.params }, void 0),
        'destek-taleplerim': _jsx(SupportRequests, { params: props.params }, void 0),
        'milli-piyango': _jsx(MilliPiyango, { lottery_type: 1 }, void 0),
        'super-piyango': _jsx(MilliPiyango, { lottery_type: 2 }, void 0),
        'banko-piyango': _jsx(MilliPiyango, { lottery_type: 3 }, void 0),
        'super-sayisal-loto': _jsx(SayisalLoto, { game_type: 0 }, void 0),
        'super-cilgin-sayisal-loto': _jsx(SayisalLoto, { game_type: 1 }, void 0),
        'super-on-numara': _jsx(SayisalLoto, { game_type: 2 }, void 0),
        'para-loto': _jsx(SayisalLoto, { game_type: 3 }, void 0),
        'destek-taleplerim-detay': _jsx(SupportDetail, {}, void 0),
        'esya-piyangosu': _jsx(Lottery, { params: props.params }, void 0),
        'oyna-kazan': _jsx(Scatch, { params: props.params }, void 0),
        'tjk': _jsx(TjkCoupons, { params: props.params }, void 0)
    };
    useEffect(function () {
        if (!subPagesRouter.hasOwnProperty(props.subpage)) {
            navigate("/");
        }
    });
    if (subPagesRouter.hasOwnProperty(props.subpage)) {
        return subPagesRouter[props.subpage];
    }
    return _jsx(_Fragment, {}, void 0);
}
